module.exports = __webpack_public_path__ + "img/global_curriculum.a710d204.png";